import { render } from "./add-client-type.vue?vue&type=template&id=037f68d2&lang=html"
import script from "./add-client-type.vue?vue&type=script&lang=js"
export * from "./add-client-type.vue?vue&type=script&lang=js"

import "./add-client-type.vue?vue&type=style&index=0&id=037f68d2&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__